import firebase from 'firebase/app';
import '@firebase/messaging';
import {firebaseConfig} from './fbConfigs'; 
import {  setStorage, getUserGroupData } from '../utils/browserStorage'; 

// import {userGroupUrlCheck} from '../utils/userGroupUrlCheck';
// import {LBL_APP_NAME} from '../configs/labelConfigs';
import * as notificationUrls from '../configs/notificationConfigs';
import {notificationReadAction} from  '../actions/fcmActions'
//import { connect } from 'react-redux';
import configureStore from '../store/configureStore';
const store = configureStore();

export const initializeFirebase = () => {

  // let userGroupData = userGroupUrlCheck(this.props.location);

  firebase.initializeApp(firebaseConfig);

  const messaging = firebase.messaging(); 

  messaging.usePublicVapidKey("BKOjGF19PucjJNGR62WiR1hc8qBbZiFPq-TKBnKAOUsASYk0U65_OSCSCTQMPxhvDfsc1G9PmZtIzsg-WrLyHMg");

      messaging.requestPermission()
      .then(function () {
          console.log("Have Push Notification Permission"); 
          return messaging.getToken(); 
      })
      .then(function (token) { 
          setStorage('fcmNotificationToken', token);
      })
      .catch(function (err) {
        console.log("Denied Push Notification Permission"); 
      })

  
      
      messaging.onMessage(function(payload) {
        console.log('Message received. ', payload);
        const title = payload.data.title; // LBL_APP_NAME;
        const options = { 
            body: payload.data.notification_string,
            icon: '/logo_small.png'
        }; 
        var notification = new Notification(title, options);

        // INCREMENT THE NOTIFICATION COUNT
        let notificationCount = 0; 
        let userGroupData  = []; 
        notification.onshow = function() { 

          userGroupData  = getUserGroupData('affiliate');
          if(userGroupData!==null){
            userGroupData.notification_count++; 
            setStorage('affiliate', JSON.stringify(userGroupData));
            notificationCount = userGroupData.notification_count; 
          }

          userGroupData  = getUserGroupData('client');
          if(userGroupData!==null){
            userGroupData.notification_count++; 
            setStorage('client', JSON.stringify(userGroupData));
            notificationCount = userGroupData.notification_count; 
          } 

          setTimeout(console.log('aaa'), 3000000);
        };
        notification.onclick = function(event){
            store.dispatch(notificationReadAction({id:payload.data.user_notif_id}));
            event.preventDefault();
            let url = notificationUrls[payload.data.action];
            let id = payload.data.event_id; 
            window.open(url+id, '_blank');
            window.focus();
        };
      }); 
}